export default "__VITE_ASSET__0d14abc9__"